import { decodeEntities } from '@wordpress/html-entities';

/**
 * Location Card component.
 * Displays a single location as a card in the list view.
 *
 * @param {Object}      props          - Component props.
 * @param {MapLocation} props.location - Location data to display.
 * @param {Function}    props.onClick  - Callback when the card is clicked (opens dialog).
 * @return {*} jsx
 */
export default function LocationCard( { location, onClick, isSelected }: { location: MapLocation; onClick: () => void; isSelected?: boolean } ) {
	const { title, city, state, color, location_type } = location;

	if ( ! title ) {
		return null;
	}

	return (
		<li>
			<button
				type="button"
				className={ `str-maps__card ${ color ? 'has-custom-color' : '' } ${ isSelected ? 'is-selected' : '' }` }
				aria-label={ `View details for ${ title }, ${ city }, ${ state }` }
				onClick={ onClick }
				style={ color ? { '--str-maps-location-color': color } as Record< string, string > : undefined }
			>
				<span className="str-maps__card-title">
					<span className="str-maps__card-title-inner">{ decodeEntities(title) }</span>
				</span>
				<p className="str-maps__card-location">
					{ city?.length ? `${ city },` : '' } { state ?? '' }
				</p>
				{ location_type && (
					<span
						className={ `str-maps__card-tag ${ color ? 'has-custom-color' : '' }` }
						style={ color ? { '--str-maps-location-color': color } as Record< string, string > : undefined }
					>
						{ decodeEntities(location_type) }
					</span>
				) }
			</button>
		</li>
	);
}
